var _path, _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 129,
    viewBox: "0 0 158 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 30.5216C158 66.0666 100.033 129 64.4423 129C28.8518 129 0 100.185 0 64.6401C0 29.0951 28.8518 0.280148 64.4423 0.280148C100.033 0.280148 158 -5.02345 158 30.5216Z",
    fill: "url(#paint0_linear_1_2787)",
    fillOpacity: 0.77
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24.668,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#cc0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6665 54.001H68.3332C66.8532 54.001 65.6798 55.1876 65.6798 56.6676L65.6665 72.6676C65.6665 74.1476 66.8532 75.3343 68.3332 75.3343H73.6665C74.3998 75.3343 74.9998 74.7343 74.9998 74.001C74.9998 73.2676 74.3998 72.6676 73.6665 72.6676H68.3332V64.6676H92.3332V56.6676C92.3332 55.201 91.1332 54.001 89.6665 54.001ZM89.6665 59.3343H68.3332V56.6676H89.6665V59.3343ZM82.9065 74.2276L80.0798 71.401C79.5598 70.881 78.7198 70.881 78.1998 71.401C77.6798 71.921 77.6798 72.761 78.1998 73.281L81.9732 77.0543C82.4932 77.5743 83.3332 77.5743 83.8532 77.0543L91.3998 69.5076C91.9198 68.9876 91.9198 68.1476 91.3998 67.6276C90.8798 67.1076 90.0398 67.1076 89.5198 67.6276L82.9065 74.2276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2787",
    x1: 79,
    y1: 0,
    x2: 79,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(63 48.668)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/payment-error.e12f90357630c7893e9fe735f99856cd.svg";
export { ForwardRef as ReactComponent };